const LATEX_REGEX = new RegExp(/^\$.*\$$/g);

export const isLatex = (str: string): boolean => Boolean(str.match(LATEX_REGEX));
